import { useMemo } from 'react'

import { useUserOrganization, useUserOrganizationSettings } from '@modules-deprecated/app/organization'

export const useIsAutoCegidIntegrationEnabled = () => {
  const { organization } = useUserOrganization()
  const { organizationSettings } = useUserOrganizationSettings()

  const isAutoCegidIntegrationEnabled = useMemo(() => {
    if (!organization?.isCegid) {
      return false
    }

    /**
     * The setting works on an opt-out basis and not all organizations have the setting defined
     * Thus if the setting is not defined or it's value is '1', we will return true
     */
    if (organizationSettings?.automaticCegidIntegration === '0') {
      return false
    }

    return true
  }, [organization?.isCegid, organizationSettings?.automaticCegidIntegration])

  return { isAutoCegidIntegrationEnabled }
}
